import { cn } from "@workspace/frontend-ui";

type Props = {
  url: string;
  providerName: string;
  align?: "left" | "center";
  className?: string;
};

const HeroProviderLogo: FC<Props> = ({
  url,
  providerName,
  align = "center",
  className,
}) => (
  <div className={cn("max-w-32 shrink-0 -ml-7", className)}>
    <img
      src={url}
      alt={providerName}
      className={cn(
        "h-full max-w-full object-contain invert",
        align === "left" && "object-left",
      )}
    />
  </div>
);

export default HeroProviderLogo;
